import React, {Component} from 'react';
import {APIClient} from "../../utils/APIClient";
import {API_URL} from "../../settings/local_settings";

import {ClientTabs} from "./ClientTabs";
import {ClientHeader} from "./ClientHeader";
import {VIEW_MODE_CLIENT_ACCOUNTS, ClientAdAccountAndStoresList} from "./ad_accounts/ClientAdAccountAndStoresList";
import {withRouterParams} from "../../utils/withRouterParams";
import {withTranslation} from "react-i18next";
import {SectionIntro} from "../elements/SectionIntro";

class ClientConnections extends Component {
    constructor(props) {
        super(props);

        this.state = {
            name: '',
            clientAdAccounts: null,
            clientStores: null,
            channels: null
        };

        this.handleClientAdAccountSuccessfullyAdded = this.handleClientAdAccountSuccessfullyAdded.bind(this);
        this.handleClientStoreSuccessfullyAdded = this.handleClientStoreSuccessfullyAdded.bind(this);
        this.handleClientAdAccountRemove = this.handleClientAdAccountRemove.bind(this);
        this.handleClientAdAccountSuccessfullyEdited = this.handleClientAdAccountSuccessfullyEdited.bind(this);

    }

    handleClientAdAccountRemove(clientAdAccountId) {
        this.setIsSaving(true);
        const removeAdAccountURL = this.getClientAdAccountRemoveURL(clientAdAccountId)
        new APIClient(removeAdAccountURL).call('GET').then((data) => {
            if (data.status === 'ERROR') {
                this.setIsSaving(false);
                alert(data.error_message);
            } else if (data.status === 'OK') {
                this.updateClientConnectionsData();
            }
        })
    }

    getClientAdAccountRemoveURL(clientAdAccountId) {
        return `${API_URL}client/ad_account/${clientAdAccountId}/remove`
    }

    handleClientAdAccountSuccessfullyAdded(clientAdAccountId) {
        this.updateClientConnectionsData();
        alert("Se ha vinculado la cuenta con éxito")
    }

    handleClientStoreSuccessfullyAdded(clientAdAccountId) {
        this.updateClientConnectionsData();
        alert("Conexión con la tienda exitosa.")
    }

    handleClientAdAccountSuccessfullyEdited(clientAdAccountId) {
        this.updateClientConnectionsData();
    }

    updateClientConnectionsData() {
        new APIClient(this.updateClientConnectionsDataURL()).call('GET').then((data) => {
            if (data.status === 'ERROR') {
                this.setIsSaving(false);
                alert(data['error_message']);
            } else if (data.status === 'OK') {
                let modalState = {
                    'is_confirming_to_link_ad_accounts_to_client': this.state.is_confirming_to_link_ad_accounts_to_client
                }

                this.setState({
                    ...this.state,
                    ...modalState,
                    isSaving: false,
                    name: data.data['name'],
                    clientAdAccounts: data.data['client_ad_accounts'],
                    clientStores: data.data['client_stores'],
                    channels: data.data['channels']
                });
            }
        })
    }

    componentDidMount() {
        this.updateClientConnectionsData();
    }

    setIsSaving(new_value) {
        this.setState({
            ...this.state,
            'isSaving': new_value
        });
    }

    toggleConfirmingLinksAdAccounts() {
        // Si estamos saliendo del modal sin aceptar
        if(this.state.is_confirming_to_link_ad_accounts_to_client) {
            this.setState({
                ...this.state,
                'is_confirming_to_link_ad_accounts_to_client': false,
                'business_unit_activating_id': null

            });
        }
        else{
            throw new Error("no tenia que haber llegado aca")
        }
    }

    render() {
        const {t} = this.props;
        return (
            <section className="section-content client-workspace-page client-accounts-page">
                <ClientHeader name={this.state.name}/>
                <ClientTabs clientId={this.props.match.params.id}/>

                <div className="section-body client-workspace-body">
                    <SectionIntro
                        kicker={t('client_sections.accounts.kicker')}
                        title={t('client_sections.accounts.title')}
                        description={t('client_sections.accounts.description')}
                    />
                </div>

                <div className="section-body h-items client-workspace-body -compact" style={{paddingBottom:'0px'}}>
                    <ClientAdAccountAndStoresList
                        mode={VIEW_MODE_CLIENT_ACCOUNTS}
                        afterSuccessfulClientAdAccountSubmit={this.handleClientAdAccountSuccessfullyAdded}
                        afterSuccessfulClientStoreSubmit={this.handleClientStoreSuccessfullyAdded}
                        clientId={this.props.match.params.id}
                        clientAdAccounts={this.state.clientAdAccounts}
                        clientStores={this.state.clientStores}
                        channels={this.state.channels}
                        clientName={this.state.name}
                        doClientAdAccountRemove={this.handleClientAdAccountRemove}
                        doClientStoreRemove={this.handleClientAdAccountRemove}
                        doClientAdAccountEdit={this.handleClientAdAccountSuccessfullyEdited}
                        doClientStoreEdit={this.handleClientAdAccountSuccessfullyEdited}
                        isSaving={this.state.isSaving}
                    />
                </div>

            </section>
        )
    }

    updateClientConnectionsDataURL() {
        return API_URL + 'client/' + this.props.match.params.id+ '/connections';
    }
}

export default withRouterParams(withTranslation()(ClientConnections));
